import {Component, EventEmitter, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {OneTimeConfirmationDialogData} from './one-time-confirmation-dialog-data';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'one-time-confirmation-dialog',
  templateUrl: './one-time-confirmation-dialog.component.html',
  styleUrls: ['./one-time-confirmation-dialog.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class OneTimeConfirmationDialogComponent {

  constructor(
    private dialogRef: MatDialogRef<OneTimeConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: OneTimeConfirmationDialogData) {}

  onApply = new EventEmitter();

  close(): void {
    localStorage.setItem(this.data.storeKey, 'false');
    this.dialogRef.close();
  }

  gotIt(): void {
    localStorage.setItem(this.data.storeKey, 'true');
    this.dialogRef.close();
    this.onApply.emit();
  }
}
